<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h4>{{ submsg }}</h4>
    <p class="mt-lg-3 mb-lg-5 pt-4">Polski Lekarz w Londynie,<br>
      przyjmuje w <a href="https://www.topmedicalclinic.co.uk/pl/croydon/" target="_blank" rel="noopener">Top Medical Clinic</a>.
    </p>
  </div>
</template>

<script>
export default {
  // name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      submsg: 'Lekarz Pediatra oraz Lekarz Medycyny Estetycznej.'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h4 {
  margin: 30px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #23b8cd;
  font-weight: bold;
}
</style>
